export default __webpack_public_path__ + "static/client-details-cover-8d8f2c76d1e81159e03ad3f51e158a1a.png";